import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';
import useLanguageSettings from './useLanguageSettings';
import i18next from 'i18next';

const LanguageSelector = () => {
    const { selectedLanguage, setSelectedLanguage, suportedLanguages } = useLanguageSettings();
    const { t } = useTranslation();

    const handleChangeLanguage = (e) => {
        const selectedLanguage = suportedLanguages.find(
            (language) => language.value === e.target.value
        );
        setSelectedLanguage(selectedLanguage);
    };

    return (
        <div className={`languageContainer ${i18next.dir() === 'rtl' ? 'left' : 'right'}`}>
            <i className="fa fa-globe lang__icon"></i>
            <select value={selectedLanguage.value} onChange={handleChangeLanguage}>
                {suportedLanguages.map((language) => {
                    return (
                        <option key={language.label} value={language.value}>
                            {`${t(
                                `common.${language.value.split('-')[0].toLowerCase()}`
                            )}`.toUpperCase()}
                            &nbsp;&nbsp;
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default LanguageSelector;
